export const ESTADOS_TURNO = [
    { id: 0, name: "Todos" },
    { id: 2, name: "Sin Confirmar" },
    { id: 3, name: "Confirmado" },
    { id: 4, name: "Pendiente de atención" },
    { id: 5, name: "En atencion" },
    { id: 6, name: "Finalizado" },
    { id: 7, name: "Cancelado" },
    { id: 10, name: "Derivado" }
];